import { Padrao } from '../generic/padrao';

export class AeroCategoria extends Padrao{

    override idTab = 232;

    descricao: string;
    sigla: string;
}
